import config from '@/config';

export function isProduction() {
  return config?.websiteBaseUrl === 'https://www.vusocial.com';
}

export function isStaging() {
  return config?.websiteBaseUrl === 'https://staging.vusocial.com';
}
